"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportReducer = void 0;
const report_component_1 = __importDefault(require("./report.component"));
const report_reducer_1 = __importDefault(require("./report.reducer"));
exports.reportReducer = report_reducer_1.default;
exports.default = report_component_1.default;
